import { render, staticRenderFns } from "./pubwin.vue?vue&type=template&id=29775f57&scoped=true&"
import script from "./pubwin.vue?vue&type=script&lang=js&"
export * from "./pubwin.vue?vue&type=script&lang=js&"
import style0 from "./pubwin.vue?vue&type=style&index=0&id=29775f57&scoped=true&lang=less&"
import style1 from "./pubwin.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29775f57",
  null
  
)

export default component.exports